
import { useEffect, useState } from "react";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import CatalogListGrid from "../../../common/catalog/CatalogListGrid";
import { catalogPageParams } from "../../../common/catalog/catalogPageSize";
import Paginator from "../../../common/paginator/Paginator";
import Skeleton from "../../../common/loading/Skeleton";
import Workshop from "../../common/workshop/Workshop";

export default function MyWorkshopSection({ isDesktop }) {
    const [workshops, setWorkshops] = useState([]);
    const [page, setPage] = useState(1);
    const [maxPageNum, setMaxPageNum] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        fetchWorkshops();
    }, []);

    useEffect(() => {
        fetchWorkshops();
    }, [page]);

    function fetchWorkshops() {
        if (isLoading) {
            return;
        }
        setIsLoading(true);
        api.workshopListMine({
            token: LoginHelper.getToken(),
            ...catalogPageParams(page),
        }).then((result) => {
            setWorkshops(result['workshops']);
            setMaxPageNum(result['max_page']);
            setIsLoading(false);
        }).catch((err) => {
            setIsLoading(false);
            if (err && err.data) {
                setErrorMessage(err.data.message);
            }
        })
    }

    return (
        <div>
            <div className="font-Vazir-700 text-[16px] text-[#666666] mb-2">کارگاه‌های من</div>
            {isLoading && workshops.length === 0 && <Skeleton variant="grid" type="workshop" count={4} />}
            <CatalogListGrid isDesktop={isDesktop}>
                {workshops && !isLoading && (
                    <>
                        {workshops.length >= 1 ? (
                            <>
                                {workshops.map(workshop => (
                                    <Workshop key={workshop.id} workshop={workshop} />
                                ))}
                            </>
                        ) : (
                            <div className="text-[#666666] font-Vazir-400 text-[14px]">
                                شما هیچ کارگاهی ندارید.
                            </div>
                        )}
                    </>
                )}
            </CatalogListGrid>
            {workshops.length >= 1 && maxPageNum >= 2 && (
                <>
                    <div className="spacer p-[20px]"></div>
                    <div className="flex flex-row justify-center">
                        <Paginator currentPage={page} maxPageNum={maxPageNum} isLoading={isLoading} onChange={(newPage) => { setPage(newPage) }} />
                    </div>
                </>
            )}
            {errorMessage && (
                <div className="text-center font-Vazir-400 text-[#cc0000]">{errorMessage}</div>
            )}
        </div>
    )
}
